import React, { useState } from 'react';
import '../styles/FormFields.css';

interface SelectFieldProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  placeholder?: string;
  allowCustom?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({ 
  label, 
  value, 
  options, 
  onChange,
  allowCustom = false
}) => {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customValue, setCustomValue] = useState('');

  const isCustomValue = !options.includes(value) && value !== '';

  const handleCustomSubmit = () => {
    if (customValue.trim()) {
      onChange(customValue.trim());
      setShowCustomInput(false);
      setCustomValue('');
    }
  };

  return (
    <div className="form-field">
      <label className="form-label">{label}</label>
      <div className="tags-container">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            className={`tag ${value === option ? 'tag-selected' : ''}`}
            onClick={() => onChange(option)}
          >
            {option}
          </button>
        ))}

        {allowCustom && !showCustomInput && !isCustomValue && (
          <button
            type="button"
            className="tag tag-custom"
            onClick={() => setShowCustomInput(true)}
          >
            + Custom
          </button>
        )}

        {allowCustom && isCustomValue && (
          <button
            type="button"
            className="tag tag-selected"
            onClick={() => setShowCustomInput(true)}
          >
            {value}
          </button>
        )}
      </div>

      {showCustomInput && (
        <div className="custom-input-container">
          <input
            type="text"
            className="custom-input"
            value={customValue}
            onChange={(e) => setCustomValue(e.target.value)}
            placeholder={`Enter custom ${label.toLowerCase()}...`}
            autoFocus
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleCustomSubmit();
              }
            }}
          />
          <div className="custom-buttons">
            <button
              type="button"
              className="custom-btn-cancel"
              onClick={() => {
                setShowCustomInput(false);
                setCustomValue('');
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="custom-btn-add"
              onClick={handleCustomSubmit}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectField;





